interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  alignment?: 'left' | 'center';
  light?: boolean;
}

export const SectionHeading = ({
  eyebrow,
  title,
  subtitle,
  alignment = 'center',
  light = false,
}: SectionHeadingProps) => {
  const containerClass =
    alignment === 'center'
      ? 'text-center max-w-3xl mx-auto mb-16'
      : 'max-w-xl mb-16';

  return (
    <div className={containerClass}>
      {eyebrow && (
        <span
          className={`font-bold tracking-widest uppercase text-sm block mb-4 ${
            light ? 'text-white/80' : 'text-primary'
          }`}
        >
          {eyebrow}
        </span>
      )}
      <h2
        className={`text-4xl font-extrabold mb-6 ${
          light ? 'text-white' : 'text-heading'
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={light ? 'text-slate-200' : 'text-body'}>{subtitle}</p>
      )}
    </div>
  );
};
